// Featured PlatypusBox projects that have public demos (YouTube / Play Store).
// These are merged with the generated repo list in AllProjects.jsx.
import snakeImage from '../images/snake.jpg';
import titoImage from '../images/tito.png';
import hc05Image from '../images/hc-05.png';
import motherImage from '../images/mother.jpg';
import lipSyncAIImage from '../images/LipSyncAI.png';

const yt = (id) => `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
const YT = (id) => ({ type: 'youtube', label: 'Watch demo', url: `https://youtu.be/${id}` });
const PLAY = (label, url) => ({ type: 'play', label, url });

export const featuredProjects = [
  {
    id: 'hc05-controller',
    title: 'HC-05 Controller',
    category: 'IoT & Hardware',
    tagline: 'Control Arduino via Bluetooth and voice commands.',
    description: 'Control an Arduino over Bluetooth with text and voice commands.',
    tags: ['Bluetooth control', 'Voice/Text input', 'Arduino'],
    image: hc05Image,
    links: [YT('nbuaMPzQzr4')],
  },
  {
    id: 'mothers-dont-water-plants',
    mergeWith: 'MyMotherDontWaterPlants',
    title: "Mothers don't water plants",
    category: 'IoT & Hardware',
    tagline: 'Remote plant watering system using IoT.',
    description: 'Remote plant watering system using IoT, controlled from an Android app.',
    tags: ['IoT system', 'Remote control', 'Android App'],
    image: motherImage,
    links: [PLAY('Play Store', 'https://play.google.com/store/apps/details?id=com.MacShangamers.MothersDontWaterPlants')],
  },
  {
    id: 'lip-sync-ai',
    title: 'Lip Sync AI Demo',
    category: 'AI & Vision',
    tagline: 'AI-based facial and lip synchronization demo.',
    description: 'AI-based facial and lip synchronization with emotion capture.',
    tags: ['Lip sync AI', 'Emotion capture', 'ML powered'],
    image: lipSyncAIImage,
    links: [YT('fyWECP-d-YM')],
  },
  {
    id: 'tower-defence',
    title: 'Tower Defence',
    category: 'Games',
    tagline: 'Build, defend and survive endless waves.',
    description: 'Build, defend, and survive against endless waves of enemies in this immersive strategy game.',
    tags: ['Unique defence strategies', 'Powerful upgrades', 'Immersive gameplay'],
    image: yt('g4bkWame0WQ'),
    links: [YT('g4bkWame0WQ')],
  },
  {
    id: 'platypus-warcraft',
    title: 'PLATYPUS WARCRAFT',
    category: 'Games',
    tagline: 'Stunning visuals, advanced mechanics, smooth controls.',
    description: 'An AI-powered game with stunning visuals, advanced mechanics, and smooth controls from PlatypusBox.',
    tags: ['Stunning visuals', 'Advanced mechanics', 'Smooth controls'],
    image: yt('K6r_wSRG3wI'),
    links: [YT('K6r_wSRG3wI')],
  },
  {
    id: 'real-estate-platform',
    title: 'REAL ESTATE Platform',
    category: 'Mobile & Web Apps',
    tagline: 'Simple, fast and user-friendly real estate platform.',
    description: 'A modern real estate platform designed for simplicity, speed, and a user-friendly experience.',
    tags: ['Easy navigation', 'Modern interface', 'Web platform'],
    image: yt('8S4RxtgGVPM'),
    links: [YT('8S4RxtgGVPM')],
  },
  {
    id: 'crashland',
    title: 'Crashland',
    category: 'Games',
    tagline: 'Every move decides your fate.',
    description: 'The ultimate survival challenge where every move decides your fate. Can you survive the madness?',
    tags: ['Dangerous terrains', 'Unpredictable crashes', 'Extreme survival'],
    image: yt('8-xDLbYkTtc'),
    links: [YT('8-xDLbYkTtc')],
  },
  {
    id: 'dynamic-drift',
    title: 'Dynamic Drift',
    category: 'Games',
    tagline: 'Ships that race, fly and drift across insane maps.',
    description: "A high-octane racing game where ships don't just race, they fly and drift across insane maps.",
    tags: ['Ground and air racing', '3 unique maps', '4 ship variants'],
    image: yt('4yXsqlB4_HE'),
    links: [YT('4yXsqlB4_HE')],
  },
  {
    id: 'robo-arm-simulator',
    title: 'Robo Arm Simulator',
    category: 'Simulation & Tools',
    tagline: 'Realistic robotic arm movement and automation.',
    description: 'A futuristic demo showcasing realistic robotic arm movement and next-gen automation by PlatypusBox.',
    tags: ['Robotic arm', 'Automation', 'Simulation'],
    image: yt('pavMPEHnPtk'),
    links: [YT('pavMPEHnPtk')],
  },
  {
    id: 'design-and-ware',
    title: 'Design & Ware',
    category: 'Games',
    tagline: 'Futuristic strategy with immersive graphics.',
    description: 'A futuristic strategy game that blends cutting-edge design, strategy, and thrilling gameplay into one immersive experience.',
    tags: ['Strategic design', 'Fast-paced action', 'Immersive graphics'],
    image: yt('tLRCKU28exw'),
    links: [YT('tLRCKU28exw')],
  },
  {
    id: 'isoshot-game',
    title: 'IsoShot Game',
    category: 'Games',
    tagline: 'Every shot counts.',
    description: 'A precision-based shooting game that tests your reflexes, timing, and strategy.',
    tags: ['Addictive shooting', 'Minimal design', 'Easy to play, hard to master'],
    image: yt('ifYDCnn7uR0'),
    links: [YT('ifYDCnn7uR0')],
  },
  {
    id: 'virtual-ivf-training',
    title: 'Virtual IVF Training System',
    category: 'Simulation & Tools',
    tagline: 'Learn IVF procedures in a safe, realistic environment.',
    description: 'A virtual training system for doctors, students and professionals to learn IVF procedures in a safe, interactive and realistic environment.',
    tags: ['Realistic IVF simulations', 'Step-by-step modules', 'Learn anytime'],
    image: yt('IfXhZYd9oGs'),
    links: [YT('IfXhZYd9oGs')],
  },
  {
    id: 'extreme-scar-racing',
    title: 'Extreme Scar Racing Madness',
    category: 'Games',
    tagline: 'Wild physics, crazy jumps and hilarious crashes.',
    description: 'Non-stop chaos: this racing game takes the wild physics of Happy Wheels to the next level with crazy jumps, impossible stunts and hilarious crashes.',
    tags: ['Physics-based racing', 'Impossible stunts', 'Non-stop action'],
    image: yt('PoihZJZ88Tk'),
    links: [YT('PoihZJZ88Tk')],
  },
  {
    id: 'circuit-clash-showdown',
    title: 'Circuit Clash Showdown',
    category: 'Games',
    tagline: 'Who will dominate the track?',
    description: 'A high-speed racing experience with heart-pounding action, jaw-dropping turns and adrenaline-fuelled moments.',
    tags: ['Intense racing', 'High-speed tracks', 'Adrenaline'],
    image: yt('4pEVaoyXdx0'),
    links: [YT('4pEVaoyXdx0')],
  },
  {
    id: 'snake-run',
    title: 'Snake Run',
    category: 'Games',
    tagline: 'Navigate obstacles in a fast-paced, retro-style game.',
    description: 'Navigate obstacles in a fast-paced, retro-style snake game with touch controls.',
    tags: ['Dynamic obstacles', 'Touch controls', 'Retro mechanics'],
    image: snakeImage,
    links: [PLAY('Play Store', 'https://play.google.com/store/apps/details?id=com.MacShangamer.SnakeRun'), YT('XAMZelcVjkc')],
  },
  {
    id: 'tito-game',
    mergeWith: 'Tito',
    title: 'Tito',
    category: 'Games',
    tagline: 'Strategic multiplayer Tic-Tac-Toe experience.',
    description: 'A strategic multiplayer Tic-Tac-Toe experience with a minimal UI and single or multiplayer modes.',
    tags: ['Minimal UI', 'Single & multiplayer', 'Kotlin built'],
    image: titoImage,
    links: [],
  },
];
